const tone = (b) => (b === "BULLISH" ? "text-[var(--r2-emerald)]" : b === "BEARISH" ? "text-[var(--r2-red,#f43f5e)]" : "text-[var(--r2-amber)]");

// Magnificent 7 bias + each member's move; the futures engine only longs indices when BULLISH, shorts when BEARISH.
export const Mag7Strip = ({ mag7 }) => {
  if (!mag7?.count) return null;
  const pct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`);
  return (
    <div data-testid="v2-mag7-strip" className="flex items-center gap-4 px-4 h-7 border-b border-[var(--r2-border)] text-[10.5px] tracking-[0.12em] overflow-x-auto whitespace-nowrap">
      <span className="text-[var(--r2-text2)]">MAG 7</span>
      <span data-testid="v2-mag7-bias" className={`font-bold ${tone(mag7.bias)}`}>{mag7.bias}</span>
      <span className="text-[var(--r2-text2)] tabular-nums">{mag7.up}↑ {mag7.down}↓ · avg <span className={mag7.avg_change_pct >= 0 ? "text-[var(--r2-emerald)]" : "text-[var(--r2-red,#f43f5e)]"}>{pct(mag7.avg_change_pct)}</span></span>
      <span className="h-3 w-px bg-[var(--r2-border)]" />
      {(mag7.members || []).map((m) => (
        <span key={m.symbol} data-testid={`v2-mag7-${m.symbol}`} className="tabular-nums">
          <span className="text-[var(--r2-text1)]">{m.symbol}</span>{" "}
          <span className={m.change_pct > 0 ? "text-[var(--r2-emerald)]" : m.change_pct < 0 ? "text-[var(--r2-red,#f43f5e)]" : "text-[var(--r2-text2)]"}>{pct(m.change_pct)}</span>
        </span>
      ))}
      <span className="ml-auto text-[var(--r2-text2)] tracking-normal">index longs only when bullish · shorts only when bearish</span>
    </div>
  );
};
